import { jsx as _jsx } from "react/jsx-runtime";
import { PreviewScale } from "./PreviewScale";
import { FullsizeScale } from "./FullsizeScale";
export const Scale = ({ scale, variant }) => {
    const { efficiencyClass, type, alternateText, name, segments, values, displayUnhappyHouseIcon, } = scale;
    if (variant === "preview") {
        return (_jsx(PreviewScale, { efficiencyClass: efficiencyClass, type: type, alternateText: alternateText, name: name }));
    }
    if (variant === "fullsize") {
        return (_jsx(FullsizeScale, { efficiencyClass: efficiencyClass, type: type, segments: segments, values: values, name: name, alternateText: alternateText, displayUnhappyHouseIcon: displayUnhappyHouseIcon }));
    }
    return null;
};
